import { BankOption } from './bank-selector-field.types';
import { PSP_DEFINITIONS } from 'utils/psp';

export const getList = (
    list: any,
    isSearch?: 'true' | 'false',
): BankOption[] => {
    if (!list) return [];

    const finalItems: BankOption[] = [];

    isSearch === 'true' &&
        finalItems.push({
            id: '',
            name: 'همه',
            symbol: 'EFJ',
        });

    list?.map((bank: any) =>
        finalItems.push({
            id: bank.id,
            name: bank.name.replace(/^بانک\s+/, ''),
            symbol: bank?.symbol,
        }),
    );

    return finalItems;
};

export function findBank(bankName: string) {
    const normalized = bankName?.trim().toLowerCase();

    return Banks.find((item) => item.icon.toLowerCase() === normalized);
}

export function findBankLogo(bankName: string): string {
    const bank = findBank(bankName);

    if (bank) return BankAssetUrl + bank.icon + '.svg';

    return '';
}

export function bankColor(bankName: string): Object {
    const bank = findBank(bankName);
    if (bank && bank.colors) return bank.colors;

    return {};
}

export const BankAssetUrl = '/images/bank-logo/';

export const Banks = [
    {
        name: 'صادرات ایران',
        icon: 'BSI',
    },
    {
        name: 'ملت',
        icon: 'MEL',
    },
    {
        name: 'تجارت',
        icon: 'TEJ',
    },
    {
        name: 'ملی ایران',
        icon: 'BMI',
    },
    {
        name: 'سپه',
        icon: 'BSP',
    },
    {
        name: 'کشاورزی',
        icon: 'BKV',
    },
    {
        name: 'پارسیان',
        icon: 'PAR',
        colors: {
            color: '#fff',
            orginal: 'rgb(207,138,99)',
            background:
                'linear-gradient(86deg, rgba(207,138,99,1) 0%, rgba(141,72,33,1) 100%)',
        },
    },
    {
        name: 'مسکن',
        icon: 'BMK',
    },
    {
        name: 'رفاه کارگران',
        icon: 'REF',
    },
    {
        name: 'اقتصاد نوین',
        icon: 'ENB',
    },
    {
        name: 'انصار',
        icon: 'ANS',
    },
    {
        name: 'پاسارگاد',
        icon: 'PAS',
    },
    {
        name: 'سامان',
        icon: 'SAM',
    },
    {
        name: 'سینا',
        icon: 'SIN',
    },
    {
        name: 'پست ایران',
        icon: 'PST',
    },
    {
        name: 'قوامین',
        icon: 'GHA',
    },
    {
        name: 'توسعه تعاون',
        icon: 'BTT',
    },
    {
        name: 'شهر',
        icon: 'SHR',
    },
    {
        name: 'آینده',
        icon: 'AYN',
    },
    {
        name: 'سرمایه',
        icon: 'SAR',
    },
    {
        name: 'دی',
        icon: 'DEY',
    },
    {
        name: 'حکمت ایرانیان',
        icon: 'hi',
    },
    {
        name: 'ایران زمین',
        icon: 'IRZ',
    },
    {
        name: 'کارآفرین',
        icon: 'BKA',
    },
    {
        name: 'گردشگری',
        icon: 'GAR',
    },
    {
        name: 'صنعت و معدن',
        icon: 'BSM',
    },
    {
        name: 'توسعه صادرات',
        icon: 'edbi',
    },
    {
        name: 'خاورمیانه',
        icon: 'KHMI',
    },
    {
        name: 'رسالت',
        icon: 'RES',
    },
    {
        name: 'مهر ایران',
        icon: 'MHR',
    },
    {
        name: 'موسسه اعتباری ملل',
        icon: 'ASKC',
    },
    {
        name: 'موسسه اعتباری نور',
        icon: 'NOR',
    },
    ...PSP_DEFINITIONS.map((psp) => ({
        name: psp.label,
        icon: psp.code.toUpperCase(),
    })),
];
